<template>
  <transition
    appear
    @before-appear="beforeAppear"
    @appear="enter"
    @enter="enter"
    @leave="leave">
    <router-link
      v-hover-scale-mouse
      data-apollo-hover
      tag="h3"
      :to="this.link"
      class="chapter"
      @mouseenter.native="mEnter"
      @mouseleave.native="mLeave">
      Discover
    </router-link>
  </transition>
</template>

<script>
import anime from 'animejs';
import { SplitText } from '@/scripts/SplitText';
import letterSpacingAnimation from '@/mixins/letterSpacingAnimation';

export default {
  name: 'HeroDiscover',
  mixins: [letterSpacingAnimation],
  computed: {
    link() {
      return this.$store.getters.getCurrentPage.path;
    },
  },
  mounted() {
    return new SplitText(this.$el, { charsClass: 'stagger-element' });
  },
  methods: {
    beforeAppear(el) {
      anime.set(el, {
        opacity: 0,
      });
    },
    enter(el, done) {
      anime({
        targets: el,
        opacity: 1,
        duration: 300,
        easing: 'easeInCubic',
        complete() {
          done();
        },
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        opacity: 0,
        duration: 800,
        easing: 'easeOutCubic',
        complete() {
          done();
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.chapter {
  padding: 1em;

  text-transform: uppercase;

  cursor: pointer;

}
</style>
